(function (root, document, $) {
    'use strict';

    var __ = wp.i18n.__;

    var app = {
        mecSelectedVariation: null,
        printValues: {},
        attachmentsValues: {},

        init: function () {
            this.win = $(window);
            this.doc = $(document);
            this.body = $('body');
            this.html = $('html');
            this.currentPos = '';

            for (var name in this) {
                if (this[name] !== null && typeof this[name] === 'object' && typeof (this[name].init) === 'function') {
                    this[name].init();
                }
            }
        },

        headerFunctions: {
            init: function () {
                var scope = this;

                var $header = $('header.site-header');
                var hasMegamenu = $('li.has-megamenu > a');

                if ($('.navbar.mobile').length) {
                    hasMegamenu.on('click', function () {
                        const clickedItem = $(this).parent();
                        hasMegamenu.parent().not(clickedItem).removeClass('active');
                        clickedItem.toggleClass('active');
                        app.body.toggleClass('offset-menu-visible');
                    });
                }
            }
        },

        offsetMenu: {
            init: function () {
                var $trigger = $('#toggle-menu'),
                    $offsetMenu = $('.burger-menu');

                $trigger.on('click', function () {
                    $(this).toggleClass('open');
                    $offsetMenu.toggleClass('visible');
                    app.body.toggleClass('offset-menu-visible');
                });

                var $items = $('.burger-menu--navigation .menu-item-has-children > a, .burger-menu--navigation__top .menu-item-has-children > a, .burger-menu--navigation__top .has-megamenu > a'),
                    caret = '<span class="sub-menu-caret"><i class="fas fa-caret-down"></i></span>';

                $items.each(function () {
                    $(this).append(caret);
                });

                $('.sub-menu-caret').on('click', function (e) {
                    e.preventDefault();
                    if ($(this).parent().hasClass('sub-open')) {
                        $(this).parent().next().slideUp(200);
                        $(this).parent().removeClass('sub-open');
                    } else {
                        $(this).parent().next().slideDown(200);
                        $(this).parent().addClass('sub-open');
                    }
                });

                $('.site-overlay').on('click', function () {
                    if ($offsetMenu.hasClass('visible')) {
                        $offsetMenu.removeClass('visible');
                        $trigger.removeClass('open');
                        app.body.removeClass('offset-menu-visible');
                    }
                });

            }
        },

        selectedProductsSlider: {
            init: function () {

                if ($('.block.selected-products.slider-wrapper').length === 0)
                    return;

                var slickArgs = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    centerPadding: '60px',

                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 480,
                            settings: {
                                centerPadding: '100px',
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: 'unslick'
                        }
                    ]
                };

                var $prodSlider = $('.product-slider-container');
                $prodSlider.slick(slickArgs);

                var resizeTimer;
                app.win.on('resize', function (e) {
                    //A smarter resizer
                    var winWidth = app.win.innerWidth();
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function () {
                        if (winWidth <= 576) {
                            $prodSlider.slick(slickArgs);
                        }
                    }, 100);
                });
            }
        },

        toggleSearch: {
            init: function () {
                var $trigger = $('#toggle-search'),
                    $searchForm = $('.search-form-wrapper'),
                    $input = $searchForm.find('#s');

                $trigger.on('click', function () {
                    $searchForm.slideToggle(200);

                    if ($(this).hasClass('open')) {
                        $input.blur();
                    } else {
                        $input.focus();
                    }

                    $(this).toggleClass('open');
                });
            }
        },

        footerCalculations: {
            init: function () {

                var scope = this;
                var winWidth = app.win.innerWidth();

                scope.calculations(winWidth);

                app.win.on('resize', function () {
                    var winWidth = app.win.innerWidth();
                    scope.calculations(winWidth);
                });
            },
            calculations: function (winWidth) {

                var columns;

                if (winWidth > 992) {
                    columns = 3;
                } else {
                    columns = 2;
                }

                var $list = $('ul.footer-links'),
                    $item = $list.find('li'),
                    itemHeight = $item.outerHeight(),
                    amount = $item.length,
                    calcHeight = Math.ceil(amount / columns),
                    itemFlex = Math.floor(100 / calcHeight),
                    listheight = itemHeight * calcHeight + 5;

                // $item.css('flex', '0 0' + itemFlex + '%');
                $list.css('height', listheight + 'px');
            }
        },

        accordionBlock: {
            init: function () {

                if ($('section.block.accordions-block').length === 0)
                    return;

                var $trigger = $('.accordion__title'),
                    $targets = $('.accordion__content');

                $trigger.on('click', function () {
                    if (!$(this).next().is(':visible')) {
                        $targets.slideUp(200);
                        $trigger.removeClass('active');
                        $(this).next().slideDown(200);
                        $(this).addClass('active');
                    } else {
                        $targets.slideUp(200);
                        $trigger.removeClass('active');
                    }
                });
            }
        },

        howItWorksSvg: {
            init: function () {
                var $howItWorksWrapper = $('.accordions-block .animation-wrapper');
                var $howItWorksSvg = $('.accordions-block .animation-wrapper > svg');

                if ($howItWorksWrapper.length) {
                    $howItWorksWrapper.addClass('in-view');
                }

                $(window).scroll(function () {
                    if ($howItWorksWrapper.length) {
                        $howItWorksWrapper.addClass('in-view');
                    }
                });
            },
        },

        getCommonProductVariations: {
            init: function () {
                const appRef = app;
                const self = this;
                
                const $mecVariations = $('.js-mec-variations');
                let $variations = $mecVariations.find('.variation');
                let $dropdowns = $('.variation_dropdowns');
                const $toggleButton = $('.js-toggle-variations');
                const $toggleButtonWrapper = $('.js-toggle-variations-wrapper');
                let $select = $('.js-select');

                // Initial button check on page load
                self.updateButton();
                self.mecAttachments();
                
                if ($variations.length > 2) {
                    // Hide all .variation elements beyond the first two
                    $variations.slice(2).hide();
                    $toggleButtonWrapper.addClass('active');
            
                    // Toggle button click event
                    $toggleButton.on('click', function () {
                        var isExpanded = $toggleButton.hasClass('expanded');
                        
                        if (isExpanded) {
                            // Hide extra variations and update button text
                            $variations.slice(2).slideUp();
                            $toggleButton.text(`${translations.visa_fler}`).removeClass('expanded');
                        } else {
                            // Show all variations and update button text
                            $variations.slice(2).slideDown();
                            $toggleButton.text(`${translations.visa_farerre}`).addClass('expanded');
                        }
                    });
                }

                if ($dropdowns.length) {
                    $dropdowns.each(function() {
                        $(this).find('option:eq(1)').prop('selected', true);
                    });

                    $dropdowns.trigger('change');
                }

                if ($select.length) {
                    $select.select2({
                        minimumResultsForSearch: Infinity,
                        width: '100%',
                    });
                }

                if ($('.color-select, .location-select').length) {
                    $('.color-select, .location-select').on('change', function () {
                        var row = $(this).closest('.row');
                        var colorSelected = row.find('.color-select').val();
                        var locationSelected = row.find('.location-select').val();

                        row.nextAll('.error-message').remove();

                        if ((colorSelected && locationSelected) || (colorSelected === "" && locationSelected === "")) {
                            if ($mecVariations.find('.error-message').length === 0) {
                                $mecVariations.removeClass('form-has-error');
                            }
                        } else {
                            $mecVariations.addClass('form-has-error');

                            if (colorSelected && !locationSelected) {
                                var errorMessage = $(`<div class="error-message">${translations.logoplacering}</div>`);
                                row.after(errorMessage);
                            } else if (!colorSelected && locationSelected) {
                                var errorMessage = $(`<div class="error-message">${translations.tryckfarger}</div>`);
                                row.after(errorMessage);
                            }
                        }
                    });
                }

                if ($mecVariations) {
                    $mecVariations.find('.js-select').on('change', function(){
                        var parentVariation = $(this).closest('.variation');
                            
                        var printType = parentVariation.data('type-print');
                        // Get selected values from the dropdowns
                        var value1 = parentVariation.find('.js-select[name$="_color"] option:selected').text();
                        var value2 = parentVariation.find('.js-select[name$="_location"]').val();
                        var value3 = parentVariation.find('.label').text().trim();
                        // Only add to results if both dropdowns have a selected value
                        if (value1 && value2) {
                            appRef.printValues[printType] = {
                                label: value3,
                                color: value1,
                                location: value2
                            };
                        } else {
                            delete appRef.printValues[printType];
                        }

                        self.updateButton();
                    });
                }
            },

            updateButton: function() {
                const appRef = app;
                const self = this;

                var $buttonContainer = $('.js-button-container');
                var productTitle = $buttonContainer.data('btn-title');
                var fileUploadDisabled = $buttonContainer.data('file') === true;

                if (fileUploadDisabled || Object.keys(appRef.printValues).length > 0) {
                    // Display "Beställ" button
                    $buttonContainer.html(`<a href="javascript:;" class="btn btn--primary open-lightbox" data-fancybox data-src="#upload-attachment-lightbox" data-options=\'{"touch": false}\'> ${translations.bestall} ${productTitle}</a>`);
                } else {
                    // Display default "Lägg till" button
                    $buttonContainer.html(`<button id="submit-form" class="btn btn--primary w-100 js-order-btn"><i class="fas fa-shopping-cart"></i> ${translations.lagg_till}</button>`);
                    self.bindAddButtonValidation();
                }
            },

            bindAddButtonValidation: function() {
                $('.js-order-btn').on('click', function(e) {
                    var $this = $(this);
                    var $variations = $this.closest('.wrapper-variations');
                    if ($variations.length) {
                        var valid = true;
                        var $dropdowns = $variations.find('select.variation_dropdowns');
                        $dropdowns.each(function() {
                            var $selected = $(this).find(':selected');
                            if ($selected.val() === '') {
                                valid = false;
                            }
                        });
                        if (!valid) {
                            e.preventDefault();
                            alert(`${translations.produktalternativ}`);
                        }
                        return valid;
                    }
                });
            },

            mecAttachments: function() {
                const appRef = app;

                const $multipleSelect = $('.js-multiple-select');

                if ($multipleSelect.length) {
                    $multipleSelect.each(function () {
                        const $this = $(this);

                        $this.select2({
                            multiple: true,
                            placeholder: 'Välj',
                            templateResult: formatOptionWithImageAndDescription,
                            templateSelection: formatSelectedOption,
                        });

                        $this.data('select2').$dropdown.addClass('custom-dropdown');

                        $this.on('select2:select', function (e) {
                            const selectedElement = $(e.params.data.element);
                            const selectedGroup = selectedElement.closest('optgroup');

                            if (selectedGroup.length) {
                                const selectedOptions = selectedGroup.find('option:selected');

                                if (selectedOptions.length > 1) {
                                    selectedOptions.not(selectedElement).prop('selected', false);
                                    $this.trigger('change.select2'); // Ensure Select2 UI updates properly
                                }
                            }
                        });
                    });

                    function formatOptionWithImageAndDescription(option) {
                        if (!option.id) return option.text;

                        const $element = $(option.element);
                        const imgUrl = $element.data('image') || '';
                        const description = $element.data('description') || '';

                        return $(`
                            <span class="row item-row">
                                ${imgUrl ? `<span class="col-auto col-image"><img src="${imgUrl}" alt="${option.text}" style="width: 135px; height: 135px;" /></span>` : ''}
                                <span class="col col-text">
                                    <strong class="title">${option.text}</strong>
                                    ${description ? `<small>${description}</small>` : ''}
                                </span>
                            </span>
                        `);
                    }
            
                    function formatSelectedOption(option) {
                        if (!option.id) {
                            return option.text; // Return the placeholder text
                        }
            
                        // Only return the text (title) without the description
                        return option.text;
                    }

                    $multipleSelect.on('change', function () {
                        if ($multipleSelect.length > 0) {
                            const selectedValues = $multipleSelect.val() || []; // Get selected values or an empty array
                            const allOptions = $multipleSelect.find('option'); // Get all options
                    
                            // Add selected values to the attachmentsValues object
                            selectedValues.forEach(value => {
                                const option = $multipleSelect.find(`option[value="${value}"]`);
                                const nameAttachment = option.text().trim();
                                const valueAttachment = option.val();
                                appRef.attachmentsValues[value] = {
                                    name: nameAttachment,
                                    number: valueAttachment,
                                };
                            });

                            
                    
                            // Remove unselected values from attachmentsValues object
                            allOptions.each(function () {
                                const value = $(this).val();
                                if (!selectedValues.includes(value)) {
                                    delete appRef.attachmentsValues[value];
                                }
                            });
                        }
                    });
                    
                    
                }
            }
        }, 

        getMecVariations: {
            init: function () {
                const appRef = app;

                sessionStorage.removeItem('mecData');

                // Function to save mecData to sessionStorage
                function saveToSession(mecData) {
                    sessionStorage.setItem('mecData', JSON.stringify(mecData));
                }

                // Function to retrieve mecData from sessionStorage
                function loadFromSession() {
                    const storedData = sessionStorage.getItem('mecData');
                    return storedData ? JSON.parse(storedData) : {};
                }

                // Load initial data from sessionStorage
                let mecData = loadFromSession();

                const $parent = $('.js-get-all-variations');
                
                // Function to update the object with the selected or entered value
                function updatemecData($element) {
                    const elementName = $element.attr('name');  // Get the name of the element
                    const elementValue = $element.val();  // Get the current value of the element
                    mecData[elementName] = elementValue;  // Store in the object
                    saveToSession(mecData);  // Save the updated object to sessionStorage
                }

                // Find all select elements inside the parent
                const $elements = $parent.find('select, input').not('[name="variable-price"]');

                // Attach event listener to each select element
                $elements.each(function() {
                    const $element = $(this);

                    // Update the object with the current value when the page loads
                    updatemecData($element);

                    // Listen for changes and update the object
                    $element.on('change', function() {
                        updatemecData($element);
                    });
                });

                // Display the SKU:
                $('form.variations_form').on('found_variation', function(event, variation) {
                    const variation_sku = variation.sku;
                    $('#variation-sku-display').text(variation_sku);
                    const customAttrs = loadFromSession();

                    appRef.mecSelectedVariation = variation.variation_id;

                    $.ajax({
                        url: ajax.ajaxurl,
                        type: 'POST',

                        data: {
                            action: 'get_custom_variation_price',
                            variation_id: variation.variation_id,
                            customAttrs: customAttrs,
                        },

                        beforeSend: function() {
                            $('.mec-price').addClass('skeleton');
                            $('.mec-delivery-time').addClass('skeleton');
                        },

                        success: function(response) {
                            const $mec = $('.mec-price');
                            if ($mec.length) {
                                const vat = response.data.vat ? 'inkl. moms' : 'exkl. moms';

                                $mec.first().html(
                                    `${response.data.new_price_total} kr. ${vat} <span class="mec-price-per-unit">${response.data.new_price}/st</span>`
                                );
                            }

                            $mec.removeClass('skeleton');
                            $('.mec-delivery-time').removeClass('skeleton');
                        },
                        error: function(error) {
                            console.log('Error:', error);
                        }
                    });
                });
            
                // Clear SKU display if no variation is selected
                $('form.variations_form').on('reset_data', function() {
                    $('#variation-sku-display').text('');
                });
            }
        },


        productDescription: {
            init: function () {
                var $tab = $('.product-description .tab');
                var $desc = $('.product-description');
                var $slutformatTrigger = $('.slutformat-info-trigger');
                var $slutformatContent = $('.slutformat-info-content');

                $tab.click(function () {
                    $desc.toggleClass('active');
                });

                $slutformatTrigger.click(function () {
                    if (app.win.innerWidth() <= 768) {
                        $slutformatContent.slideToggle();
                    }
                });

                // Move price inside container
                var $price = $('.main-content p.price');
                var $quantity = $('.main-content .quantity');

                $price.insertBefore($quantity);
            }
        },

        productTabs: {
            init: function () {
                var $btns = $('.js-read-more');
                var $tabs = $('.woocommerce-tabs');

                [...$btns].forEach(function (item) {
                    item.addEventListener('click', function (e) {
                        e.preventDefault();
                        item.classList.add('d-none');
                        var parentItem = item.parentElement.querySelector(".woocommerce-product-details__short-description");
                        parentItem.classList.remove('woocommerce-product-details_minimized');
                    });
                });

                function tabControl() {
                    var $tabs_items = $tabs.find('.wc-tab');
                    if ($tabs_items.length > 0) {
                        $tabs_items[0].classList.add('active');
                    }

                    document.addEventListener('click', function (e) {
                        if (e.target.classList.contains('wc-tab')) {
                            var $this = e.target;

                            [...$tabs_items].forEach(function (item) {
                                return item.classList.remove('active');
                            });

                            $this.classList.toggle('active');

                            var desiredScrollTop = $this.getBoundingClientRect().top + window.scrollY - 180;

                            window.scrollTo({
                                top: desiredScrollTop,
                                behavior: 'smooth'
                            });
                        }
                    });
                }

                var resizeTimer;
                app.win.on('resize', function (e) {
                    //A smarter resizer
                    var winWidth = app.win.innerWidth();
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function () {
                        if (winWidth <= 768) {
                            tabControl();
                        }
                    }, 100);
                });
            }
        },

        dropzone: {
            init: function () {
                var self = this;
                var $dropArea = $('#drop-area');
                var $input = $('#wau_file_addon');

                if ($input.length === 0 && $dropArea.length === 0) {
                    return;
                }

                // If input contains file on page load
                if ($input.get(0).files && $input.get(0).files.length > 0) {
                    self.inputChange();
                }

                // Dragover
                $dropArea.on('dragover', function (e) {
                    e.preventDefault();
                    $dropArea.addClass('highlight');
                });

                // Dragleave
                $dropArea.on('dragleave', function (e) {
                    e.preventDefault();
                    $dropArea.removeClass('highlight');
                });

                // Drop
                $dropArea.get(0).addEventListener('drop', function (e) {
                    e.preventDefault();
                    $dropArea.removeClass('highlight');

                    $input.get(0).files = e.dataTransfer.files;
                    self.inputChange();
                });

                // On file change
                $(document).on('change', '#wau_file_addon', function (e) {
                    self.inputChange();
                });

                // Clear uploads
                var $bin = $('.uploaded .file .bin');

                $bin.click(function () {
                    $input.val('');
                    $dropArea.removeClass('files-added');
                    self.disableSubmit();
                });
            },
            inputChange: function () {
                var self = this;
                var $input = $('#wau_file_addon');
                var $dropArea = $('#drop-area');
                var $uploadLoading = $('#upload-loading');

                if ($input.get(0).files && $input.get(0).files.length > 0) {
                    var file = $input.get(0).files[0];
                    var $fileNameEl = $('#drop-area .file .name');

                    $fileNameEl.text(file.name);
                    $dropArea.addClass('files-added');

                    self.enableSubmit();

                    // Update additional info
                    self.updateAdditionalInfo();
                }
            },
            enableSubmit: function () {
                var $submitBtn = $('#submit-form');
                $submitBtn.addClass('visible');
                $submitBtn.prop('disabled', false);
            },
            disableSubmit: function () {
                var $submitBtn = $('#submit-form');
                $submitBtn.removeClass('visible');
                $submitBtn.prop('disabled', true);
            },
            updateAdditionalInfo: function () {
                var $additionalInfo = $('#drop-area .additional-info');

                var values = [
                    {
                        sel: $('#pa_antal'),
                        target: $additionalInfo.find('.quantity:first')
                    },
                    {
                        sel: $('#pa_produktionsdagar'),
                        target: $additionalInfo.find('.production:first')
                    }
                ];

                values.forEach(function (val) {
                    val.target.text(val.sel.find("option:selected").text());

                    val.sel.change(function () {
                        val.target.text($(this).find("option:selected").text());
                    });
                });
            }
        },

        addToCart: {
            init: function () {
                const appRef = app;

                var $addedItemEl = $('nav .cart .added-item');
                // var $submit = $('#submit-form');
                var $uploadLoading = $('#upload-loading');
                var self = this;
                var $mecVariations = $('.js-mec-variations');

                $(document).on('click', '#submit-form', function (e) {
                    e.preventDefault();
                    var $form = $('form.cart')[0];
                    var $input = $('#wau_file_addon');
                    var $select = $('.js-select');
                    var $multipleSelect = $('.js-multiple-select');
                    var files;
                    var formData = new FormData($form);
                    var productID = $('input[name=product_id]').val();
                    var $badge = $('.cart .badge');
                    var $dropArea = $('#drop-area');
                    var $submitBtn = $('#submit-form');
                    var defaultText = $submitBtn.html();
                    var maxUploadSize = 300000000;

                    if ($mecVariations.hasClass('form-has-error')) {
                        // Remove any previous error message
                        $mecVariations.find('.submission-error-message').remove();

                        // Display a new error message
                        var errEl = $(`<span class="submission-error-message" style="color: red;">${translations.error_message}</span>`);
                        errEl.appendTo($mecVariations).delay(3000).fadeOut(200, function() {
                            $(this).remove(); // Remove element after fade out
                        });
                        
                        e.preventDefault(); // Prevent form submission
                        return;
                    }
                  

                    const storedData = sessionStorage.getItem('mecData');
                    const mecData = storedData ? JSON.parse(storedData) : {};

                    const getPrintValues = appRef.printValues;
                    const getAttachmentsValues = appRef.attachmentsValues;
                    const mecVariationID = $('#variation-sku-display').text();

                    formData.set('action', 'add_to_cart');
                    formData.append('mec_variaton_id', JSON.stringify(mecVariationID));
                    formData.append('print_values', JSON.stringify(getPrintValues));
                    formData.append('attachments_values', JSON.stringify(getAttachmentsValues));
                    formData.append('mec_data', JSON.stringify(mecData));

                    if ((typeof ($input.get(0)) != "undefined" && $input.get(0).files.length > 0) && $input.length > 0) {
                        files = $input.get(0).files[0];
                        var errEl = null;
                        if (files.size > maxUploadSize) {
                            errEl = $(`<span style="color: red;">${translations.maximum_file}</span>`);
                            errEl.appendTo($dropArea).delay(3000).fadeOut(200);
                            return;
                        }

                        if ($input.get(0).accept.includes(files.type) === false) {
                            errEl = $(`<span style="color: red;">${translations.file_type}</span>`);
                            errEl.appendTo($dropArea).delay(3000).fadeOut(200);
                            return;
                        }

                        formData.append('wau_file_addon', files);
                    }

                    $.ajax({
                        type: "POST",
                        dataType: "json",
                        url: ajax.ajaxurl,
                        data: formData,
                        enctype: 'multipart/form-data',
                        contentType: false,
                        processData: false,
                        timeout: 6000000,
                        beforeSend: function () {
                            $submitBtn.prop('disabled', true);
                            $submitBtn.html('<i class="fas fa-circle-notch fa-spin"></i>');
                        },
                        success: function (res) {
                            if (res.success === true) {
                                $.fancybox.close();
                                $("a.fancybox-close").trigger("click");
                                $addedItemEl.html(res.data.output);

                                $badge.text(res.data.cart_count);
                                $badge.addClass('visible');
                                
                                $select.each(function() {
                                    $(this).val(null).trigger('change'); // Clear the select2 value
                                });

                                $multipleSelect.val([]).trigger('change');
                                appRef.attachmentsValues = {}; 

                                $input.val('');
                                $dropArea.removeClass('files-added');
                                $submitBtn.removeClass('visible');
                                $submitBtn.prop('disabled', false);
                                $submitBtn.html(defaultText);

                                $('li.cart').removeClass('disabled');

                                $addedItemEl.removeClass('hidden').addClass('visible');
                                $addedItemEl.delay(5000).queue(function () {
                                    $(this).addClass('hidden').removeClass('visible').dequeue();
                                });
                            } else {
                                // File upload errorres.data
                                var errEl = $('<span style="color: red;">' + res.data + '</span>');
                                errEl.appendTo($dropArea).delay(3000).fadeOut(200);
                                $submitBtn.prop('disabled', false);
                                $submitBtn.html(defaultText);
                            }
                        },
                        error: function (req, err, errorThrown) {
                            $submitBtn.html(defaultText);
                            $submitBtn.prop('disabled', false);
                            var errEl = null;
                            if (err === "error") {
                                errEl = $(`<span style="color: red;">${translations.timed_out}</span>`);
                                errEl.appendTo($dropArea).delay(6000).fadeOut(200);
                            } else {
                                errEl = $(`<span style="color: red;">${translations.maximum_file}</span>`);
                                errEl.appendTo($dropArea).delay(3000).fadeOut(200);
                            }
                            console.log("AJAX Error:", req, err, errorThrown);
                        }
                    });

                });

            }
        },

        coupon: {
            init: function () {
                var toggleCoupon = '.toggle-coupon';
                var formInput = '.faux-coupon-form input.coupon-text';
                var formBtn = '.faux-coupon-form button.coupon-btn';

                var $realInput = $('#coupon_code');
                var $realForm = $('.checkout_coupon.woocommerce-form-coupon');
                var $realBtn = $('checkout_coupon.woocommerce-form-coupon button[type=submit]');

                // Toggle form
                $(document).on('click', toggleCoupon, function (e) {
                    var $fauxCouponForm = $('.faux-coupon-form');
                    $fauxCouponForm.slideToggle(150);
                });

                // Changes value of real input on faux input change
                $(document).on('keyup', formInput, function () {
                    $realInput.val($(this).val());
                });

                // Submit real form
                $(document).on('click', formBtn, function (e) {
                    e.preventDefault();
                    $realForm.submit();
                });
            }
        },

        account: {
            init: function () {
                var invoiceCheckbox = $('#my-pages .form-row.invoice_checkbox .input-checkbox');
                var invoiceEmail = $('#my-pages .form-row.invoice_email');
                var invoiceEmailInput = $('#my-pages .form-row.invoice_email #invoice_email');

                if (invoiceCheckbox.is(':checked')) {
                    invoiceEmail.show();
                    invoiceEmailInput.prop('required', 'required');
                }

                invoiceCheckbox.click(function (e) {
                    invoiceEmail.slideToggle(150, function () {
                        invoiceEmailInput.prop('required', function () {
                            if ($(this).is(':visible')) {
                                return 'required';
                            } else {
                                return null;
                            }
                        });
                    });
                });
            }
        },
        
        checkoutFunctions: {
            init: function () {
                $('#order_comments-description').removeClass('description');
                var toggleLogin = '.toggle-checkout-login';
                var fauxUser = '.faux-login-form input.faux-user';
                var fauxPass = '.faux-login-form input.faux-pass';
                var formBtn = '.faux-login-form button.faux-login-submit';

                var $realForm = $('form.woocommerce-form-login');
                var $realUser = $('.woocommerce-form-login #username');
                var $realPass = $('.woocommerce-form-login #password');
                var $realBtn = $('.woocommerce-form-login button[type=submit]');

                // Toggle form
                $(document).on('click', toggleLogin, function (e) {
                    e.preventDefault();

                    var $fauxCouponForm = $('.faux-login-form-wrapper');
                    $fauxCouponForm.slideToggle(150);
                });

                // Changes value of real input on faux input change
                $(document).on('keyup change', fauxUser, function () {
                    $realUser.val($(this).val());
                });

                $(document).on('keyup change', fauxPass, function () {
                    $realPass.val($(this).val());
                });

                // Submit real form
                $(document).on('click', formBtn, function (e) {
                    e.preventDefault();
                    $realBtn.click();
                });

                // Stop scrolling on checkout errors
                app.doc.ajaxComplete(function () {
                    if ($('body').hasClass('woocommerce-checkout') || $('body').hasClass('woocommerce-cart')) {
                        $('html, body').stop();
                        $('body').on('applied_coupon_in_checkout', function () {
                            setTimeout(function () {
                                if ($('.woocommerce-message').length) {
                                    window.location.reload();
                                }
                            }, 3000);
                        });
                    }
                });
            }
        },

        priceTable: {
            init: function () {
                var table = '#price_table table';

                $(document).on('click', table + ' tbody tr td:not(:first-child)', function () {
                    var antal = $(this).data('antal');
                    var produktionsdagar = $(this).data('produktionsdagar');
                    var $antalSelect = $('.container_pa_antal select');
                    var $produktionsdagarSelect = $('.container_pa_produktionsdagar select');

                    $antalSelect.val(antal);
                    $produktionsdagarSelect.val(produktionsdagar);

                    $antalSelect.change();
                    $produktionsdagarSelect.change();
                });
            }
        },

        customProductMetaData: {
            init: function () {
                var values = [
                    {
                        sel: $('#pa_antal'),
                        span: $('.flipptryck-meta-values .quantity')
                    },
                    {
                        sel: $('#pa_produktionsdagar'),
                        span: $('.flipptryck-meta-values .production')
                    },
                    {
                        sel: $('#pa_slutformat'),
                        span: $('.flipptryck-meta-values .format')
                    },
                    {
                        sel: $('#pa_sidor-med-tryck'),
                        span: $('.flipptryck-meta-values .print')
                    },
                    {
                        sel: $('#pa_papper'),
                        span: $('.flipptryck-meta-values .paper')
                    },
                ];

                values.forEach(function (val) {
                    val.span.text(val.sel.find("option:selected").text());

                    val.sel.change(function () {
                        val.span.text($(this).find("option:selected").text());
                    });
                });
            }
        },

        productPrices: {
            init: function () {
                var scope = this;
                var productionRadios = '#production_days .production_days_radio_container input[type=radio]';

                scope.update(scope);

                $('.variation_dropdowns').on('change', function () {
                    scope.update(scope);
                });

                $('.variations_form').on('click', productionRadios, function () {
                    var val = $(this).val();
                    var $produktionsdagarSelect = $('.container_pa_produktionsdagar select');

                    $produktionsdagarSelect.val(val);
                    scope.update(scope);
                });

                var $copyBtn = $('#wp-admin-bar-copy-product-template');
                var $productTemplates = $('.most-sold .product-template');

                $copyBtn.click(function (e) {
                    e.preventDefault();
                    scope.copy();
                });

                $productTemplates.click(function (e) {
                    scope.applyTemplate($(this));
                });

                scope.checkout();
            },
            checkout: function () {
                var cartItems = $('ul.shop_table > li');
                var scope = this;

                $.each(cartItems, function (key, item) {
                    var params = {};
                    var attrs = $(item).data('attributes');

                    $.each(attrs, function (key, attr) {
                        params[key.replace('attribute_pa_', '')] = attr;
                        params.product_id = $(item).data('id').toString();
                    });

                    // scope.getItemInfo(params, item);

                });

            },
            update: function (scope) {
                var selected = scope.selectedAttributes();
                scope.getPriceInfo(selected, scope);
            },
            selectedAttributes: function () {
                var dropdowns = $('.variation_dropdowns');
                var selected = {};

                if (dropdowns.length === 0) {
                    return;
                }

                $.each(dropdowns, function (key, obj) {
                    selected[obj.id.replace('pa_', '')] = obj.value;
                });

                return selected;
            },
            getPriceInfo: function (param, scope) {
                if (param === undefined) {
                    return;
                }

                param.action = 'getPriceInfo';
                param.product_id = $('input[name=product_id]').val();

               

                $.ajax({
                    type: 'GET',
                    dataType: 'json',
                    url: ajax.ajaxurl,
                    data: param,
                    success: function (data) {
                        var availableAttributes = scope.setAvailableAttributes(data.availableAttributes);

                        $('.variation_dropdowns').select2({
                            minimumResultsForSearch: Infinity,
                            placeholder: translations.select_option,
                            width: '100%',
                        });

                        if (!$('body').hasClass('measurement-product')) {
                            $('#price_container').html(data.priceTable + data.deliveryTime);
                            $('#variable-price').val(data.variation.price_with_tax);
                        }

                    },
                    error: function (error) {
                        console.log(error);
                    }
                });
            },
            getItemInfo: function (param, item) {
                var scope = this;

                if (param === undefined) {
                    return;
                }

                param.action = 'getPriceInfo';

                $.ajax({
                    type: 'GET',
                    dataType: 'json',
                    url: ajax.ajaxurl,
                    data: param,
                    success: function (data) {
                        var availableAttributes = scope.setAvailableQuantities(item, data.availableAttributes);
                    },
                    error: function (error) {
                        console.log(error);
                    }
                });
            },
            setAvailableQuantities: function (item, availableAttributes) {
                // console.log(item, availableAttributes);
            },
            setAvailableAttributes: function (availableAttributes) {
                var dropdowns = $('.variation_dropdowns');

                $.each(dropdowns, function (key, dropdown) {
                    var name = $(dropdown).attr('name').replace('attribute_pa_', '');

                    // Skip dropdowns that are not on availableAttributes list
                    if (typeof (availableAttributes[name]) === 'undefined') {
                        return;
                    }

                    $.each(dropdown, function (key, option) {
                        var value = $(option).val();
                        var found = availableAttributes[name].indexOf(value);

                        if (found === -1 && value !== '') {
                            $(option).attr('disabled', 'disabled');
                        } else {
                            $(option).removeAttr('disabled');
                        }
                    });
                });
            },

            copy: function (text) {
                var t = document.getElementById('copy');
                var dropdowns = $('.variation_dropdowns');
                var templateClipboard = [];

                $.each(dropdowns, function (key, dropdown) {
                    templateClipboard.push(dropdown.name.replace('attribute_', '') + ' : ' + $(dropdown).val());
                    templateClipboard.push('label_' + dropdown.name + ' : ' + $(dropdown).find('option:selected').text());
                });

                templateClipboard.push('price_per_unit : ' + $('.production_days_radio_container input[type=radio]:checked + label span.price-per-unit').text());

                templateClipboard = templateClipboard.join('\n');

                t.innerHTML = templateClipboard;
                t.select();

                document.execCommand('copy');

                t.innerHTML = '';
            },
            applyTemplate: function (template) {
                var data = template.data();
                var dropdowns = $('.variation_dropdowns');
                var attachId = template.data('attach-id');

                var $slide = $('.slick-slider [data-attach-id=' + attachId + ']');
                var slideIndex = $slide.data("slick-index");

                // Go to slick index of clicked template
                if ($slide.length > 0) {
                    $(".slick-slider").slick("goTo", slideIndex);
                }

                $.each(data, function (key, val) {
                    // from pascal case to dash case
                    key = key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
                    val = val.toString();

                    var $select = $('#' + key);
                    var $options = $('#' + key + ' option');

                    $options.prop('disabled', false);
                    $select.val(val);
                });

                dropdowns.change();
            }
        },

        scrollDown: {
            init: function () {
                $('.scroll-down').click(function () {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".product").offset().top - 100
                    }, 500);
                });
            }
        },

        format_image_mapping: {
            init: function () {
                var $mapping_inputs = $('.format-image-mapping');
                var mappings = [];

                // Get mappings from hidden HTML input fields
                $mapping_inputs.each(function () {
                    var val = $(this).val();
                    var unserialized = JSON.parse(val);

                    mappings.push(unserialized);
                });

                // On slutformat select change
                $(document).on('change', '#pa_slutformat', function (e) {
                    var selected = $(this).val();

                    // Set found to selected item value in mappings,
                    // or false if none found.
                    var found = mappings.find(function (item) {
                        return item.format === selected ? item : false;
                    });

                    // If mapping found, goes to selected index in the Slick slider
                    if (found) {
                        var $slide = $('.slick-slider [data-slick-index=' + found.image_index + ']');
                        var slideIndex = $slide.data("slick-index");

                        // Go to slick index of clicked template
                        if ($slide.length > 0) {
                            $(".slick-slider").slick("goTo", slideIndex);
                        }
                    }
                });
            }
        },

        inputFormat: {
            init: function () {
                var orgInput = $('.input-org .input-text');
                orgInput.keypress(function (evt) {
                    var charCode = (evt.which) ? evt.which : event.keyCode;
                    if (charCode != 46 && charCode != 45 && charCode > 31 && (charCode < 48 || charCode > 57))
                        return false;

                    return true;
                });
            }
        },

        notices: {
            init: function () {
                // Hides woocommerce-errors after timeout
                app.doc.on('DOMNodeInserted', function (e) {
                    if ($(e.target).is('ul.woocommerce-error, .woocommerce-NoticeGroup')) {
                        if ($(e.target).find('[data-terms]').length) {
                            $('#custom_checkout_terms').addClass('error');
                        } else {
                            $('#custom_checkout_terms').removeClass('error');
                        }

                        setTimeout(function () {
                            $('ul.woocommerce-error').fadeOut(200);
                        }, 5000);
                    }
                });
            }
        },

        setCustomerSession: {
            init: function () {
                $('#customer-modal .btn').click(function () {
                    var $this = $(this);
                    var info = $this.attr('id');

                    $.ajax({
                        // dataType: "json",
                        url: ajax.ajaxurl,
                        type: "POST",
                        data: {
                            action: "set_customer_type",
                            data: info
                        },
                        dataType: "html",
                        success: function (data) {
                           // Remove active class from all links
                            $('.js-set-customertype-company, .js-set-customertype-private').removeClass('active');
                            
                            // Add active class to the relevant link based on info
                            if(info === 'company') {
                                $('.js-set-customertype-company').addClass('active');
                            } else if(info === 'private') {
                                $('.js-set-customertype-private').addClass('active');
                            }
                        }, 
                        error: function(jqXHR, textStatus, errorThrown) {
                            console.log('AJAX error:', textStatus, errorThrown);
                        }
                    });
                });
            }
        },

        oldBrowwser: {
            init: function () {

                function setCookie(name, value, days) {
                    var expires = "";
                    if (days) {
                        var date = new Date();
                        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                        expires = "; expires=" + date.toUTCString();
                    }
                    document.cookie = name + "=" + (value || "") + expires + "; path=/";
                }

                function getCookie(name) {
                    var nameEQ = name + "=";
                    var ca = document.cookie.split(';');
                    for (var i = 0; i < ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                    }
                    return null;
                }

                function eraseCookie(name) {
                    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                }

                if (0 < window.navigator.userAgent.indexOf("MSIE ") || navigator.userAgent.match(/Trident.*rv\:11\./)) {
                    window.setTimeout(function () {
                        var x = getCookie('badbrowsercookieButik');

                        if (!x) {
                            setCookie('badbrowsercookieButik', 'badbrowserButik', 1);
                            $("#badBrowser").modal({
                                showClose: false
                            });
                        }
                    }, 3000);
                }
                if ($('body').hasClass("private") == false && $('body').hasClass("company") == false) {
                    window.setTimeout(function () {
                        $("#customer-modal").modal({
                            escapeClose: false,
                            clickClose: false,
                            showClose: true
                        });
                    }, 1000);
                }
            },
        },

        // Measurement product functions
        measurementProductPrices: {
            init: function () {
                var scope = this;

                // Check if on WooCommerce variable product page with measurement-product class
                if ($('body').hasClass('measurement-product')) {
                    $(document).ready(function () {
                        scope.setValuesOnPageLoad();
                        $('.variation_dropdowns').on('change', scope.handleInputChange.bind(scope));
                        $('.measurement-field__width, .measurement-field__height, .input-text.qty').on('input', scope.handleInputChange.bind(scope));
                    });
                }
            },

            setValuesOnPageLoad: function () {
                var scope = this;

                setTimeout(function () {
                    var variationId = scope.getCurrentVariationId();

                    if (variationId) {
                        scope.getVariationPrice(variationId, scope.updatePriceFields);
                    }
                }, 100);
            },

            handleInputChange: function () {
                var scope = this;

                setTimeout(function () {
                    var variationId = scope.getCurrentVariationId();
                    if (variationId) {
                        scope.getVariationPrice(variationId, scope.updatePriceFields);
                    }
                }, 100);
            },

            updatePriceFields: function (variationPrice) {
                $('#variable-price').val(variationPrice);
            },

            getVariationPrice: function (variationId, callback) {
                var scope = this;

                if (variationId === undefined) {
                    return;
                }

                $.ajax({
                    type: 'POST',
                    url: ajax.ajaxurl,
                    data: {
                        action: 'get_variation_price',
                        variation_id: variationId
                    },
                    success: function (response) {
                        var price = response.data;

                        if (callback && typeof callback === 'function') {
                            var width = parseFloat($('.measurement-field__width input[type="number"]').val()) || 0;
                            var height = parseFloat($('.measurement-field__height input[type="number"]').val()) || 0;
                            var qty = $('.input-text.qty').val() || 1; // Product quantity

                            if (width < 0) {
                                scope.enforceMinValueZero($('.measurement-field__width input[type="number"]'));
                            }

                            if (height < 0) {
                                scope.enforceMinValueZero($('.measurement-field__height input[type="number"]'));
                            }

                            // Convert width and height to meters
                            width = scope.calculateMeasurementInMeters(width);
                            height = scope.calculateMeasurementInMeters(height);

                            // Calculate total price
                            price = height * width * price * qty;

                            if (price <= 0) {
                                $('.js-order-btn').prop("disabled", true);
                                $(".js-order-btn").addClass("disabled");
                            } else {
                                $('.js-order-btn').prop("disabled", false);
                                $(".js-order-btn").removeClass("disabled");
                            }

                            // Format price with 2 decimal places and comma as separator
                            var formattedPrice = price.toFixed(2).replace('.', ',');

                            callback(formattedPrice);
                            $('.woocommerce-variation-price .price').html(formattedPrice + ' kr');
                        }

                        return price;
                    },
                    error: function (xhr, status, error) {
                        console.log('Error:', error);
                    }
                });
            },

            getCurrentVariationId: function () {
                var variationSelect = $('input.variation_id');

                if (variationSelect.length) {
                    return variationSelect.val();
                }

                return null;
            },

            calculateMeasurementInMeters: function (measurementInCm) {
                if (measurementInCm && measurementInCm === 0) {
                    return 0;
                }

                // Return measurement in meters
                return measurementInCm / 100;
            },

            enforceMinValueZero: function (inputElement) {
                var inputValue = parseInt(inputElement.val());

                if (inputValue < 0) {
                    inputElement.val('0');
                }
            }
        },

        mecQuantityMessage: {
            init: function () {
                const $inputQty = $('input.qty');
                const minimumQuantity = parseInt($inputQty.attr('min'));
                const $messageElement = $('.minimum-quantity-notice');

                if (!$messageElement.length || !$inputQty.length) {
                    return;
                }

                $inputQty.on('change keyup', function() {
                    const currentQuantity = parseInt($(this).val());

                    $messageElement.toggle(currentQuantity < minimumQuantity);
                });
            }
        },

        mecPriceUpdate: {
            init: function() {
                const appRef = app;

                const debounce = (func, wait) => {
                    let timeout;
                    return function(...args) {
                        clearTimeout(timeout);
                        timeout = setTimeout(() => func.apply(this, args), wait);
                    };
                };

                $('.wrapper-variations').on('change', 'input, select', debounce(function() {
                    const storedData = sessionStorage.getItem('mecData');
                    const mecData = storedData ? JSON.parse(storedData) : {};

                    if (!appRef.mecSelectedVariation) {
                        return;
                    }

                    $.ajax({
                        url: ajax.ajaxurl,
                        type: 'POST',

                        data: {
                            action: 'get_custom_variation_price',
                            variation_id: appRef.mecSelectedVariation,
                            customAttrs: mecData,
                        },

                        beforeSend: function() {
                            $('.mec-price').addClass('skeleton');
                            $('.mec-delivery-time').addClass('skeleton');
                        },

                        success: function(response) {
                            const $mec = $('.mec-price');
                            if ($mec.length) {
                                const vat = response.data.vat ? 'inkl. moms' : 'exkl. moms';

                                $mec.first().html(
                                    `${response.data.new_price_total} kr. ${vat} <span class="mec-price-per-unit">${response.data.new_price}/st</span>`
                                );

                                // Update the hidden input field with the new price
                                const $stdPrice = $('#variable-price');
                                if ($stdPrice.length) {
                                    $stdPrice.val(response.data.new_price_raw);
                                }
                            }

                            $mec.removeClass('skeleton');
                            $('.mec-delivery-time').removeClass('skeleton');
                        },
                        error: function(error) {
                            console.log('Error:', error);
                        }
                    });
                }, 600));
            }
        },
    };

    var heroSlider = {
        init: function () {
            if ($('.block.hero.hero-slider').length === 0)
                return;

            let slickArgs = {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                speed: 500,
                fade: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3500,
            };

            let $slider = $('.js-hero-slider');
            $slider.slick(slickArgs);
        }
    }
    // publish
    root.app = app;
    heroSlider.init();
    // init
    $(root).ready(function () {
        app.init();
    });
})(window, document, jQuery);
